import React, { useEffect, useState, useRef } from "react";
import {
  SwitchButtonComponet,
  TextIconButtonComponent,
} from "../../../../component/atom";
import { Box, Grid, Typography } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import DropDownComponent from "../../../../component/atom/Inputs/DropDown";
import TableComponent from "../../../../component/atom/Table/TableComponent";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import AddStudentForm from "../../../../component/molecule/Forms/AddStudentForm";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import TextButtonComponet from "../../../../component/atom/Buttons/TextButton";
import AddReviewForm from "../../../../component/molecule/Forms/courseAdmin/AdminAddReviewForm";
import { useNavigate, useLocation } from "react-router-dom";
import { setTopLevelNavigator } from "../../../../core/services/NavigationServicd";
import _ from "lodash";
import { Label } from "@mui/icons-material";
import { EXISTING_COURSE_STATUS, REGISTRED_COURSE_STATUS, renderTruncatedText } from "../../../../core/Constant"
import PlanSelectionDialog from "../../../../component/molecule/Dialog/PlanSelectionDialog";

const AdminCourseStudentManageScreen = ({
  getAdminCourseStudentList,
  courseStudentsList,
  updateStudentCourseStatus,
  courseList,
  studentStatus,
  updateStudentStatus,
  courseCurrencies,
  getCourseCurruncies
}) => {
  const [OpenReview, setOpenReview] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [courseId, setCourseId] = useState(0);
  const [studentId, setStudentId] = useState(0);
  const [courseName, setCourseName] = useState(0);
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [plans, setPlans] = useState([])
  const [isFree, setFree] = useState("")
  const [selectPlanOpen,setSelectPlanOpen] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState("")
  const [selectedStudent, setSelectedStudent] = useState("")
  const [planExpiryDate, setPlanExpiryDate] = useState();
  const [planExpiryDateError, setPlanExpiryDateError] = useState()
  const [isPlanExpiryDateValid, setPlanExpiryDateValid] = useState(false)

  const hasExecuted = useRef(1);
  const navigate = useNavigate();

  const location = useLocation();
  const onNavigate = (path, obj = {}) => {
    if (path) {
      navigate(path, obj);
    }
  };

  useEffect(() => {
    const id = location?.state?.id;
    const course = location?.state?.courseData 
    setCourseId(id);
    setCourseName(location?.state?.courseData[1]);
    getAdminCourseStudentList({
      course: id,
      type: 2,
    });
    getCourseCurruncies(id);
    if(course){
      const isFree = course?.[7]
      if(isFree === EXISTING_COURSE_STATUS?.FREE){
       setFree(true)
      } else {
       setFree(false)
      }
    }
  }, [location]);

  useEffect(() => {
    if(courseCurrencies?.length > 0){
      setPlans(courseCurrencies);
    } else {
      setPlans([]);
    }
  }, [courseCurrencies]);

  useEffect(() => {
    const list = _.map(courseStudentsList, (item) => {
      const courseStatus = item?.payment_details?.status;
      return { ...item, courseStatus };
    });

    setStudentList(list);
    const activeCount = list.filter((item) => item.is_active == '1' && item.courseStatus == '1').length;
    setActiveUserCount(activeCount);

  }, [courseStudentsList]);

  const onNavigateUser = (tableMeta,value) =>{
    onNavigate("/admin-course-student-progress",{});

  }

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "course_id",
      label: "",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "first_name",
      label: "First Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },

    { name: "whatsapp_phone_number", label: "WhatsApp number", options: { filter: false, sort: false } },
    {
      name: "courseStatus",
      label: "Course Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <SwitchButtonComponet
              checked={value ? true : false}
              onChange={() => updateAdminStatus(tableMeta, value)}
              inputProps={{ "aria-label": "controlled" }}
            />
          );
        },
      },
    },
    {
      name: "is_active",
      label: "Student Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
           value?'Active':'Inactive'
          );
        },
      },
    },
  ];

  const updateAdminStatus = (tableMeta, value) => {
    const updatedStudents = studentList?.map((item) => {
      if (item?.id == tableMeta?.rowData[0]) {
        const { courseStatus, id } = item;
        const updatedStatus = courseStatus ? 0 : 1;
        if(updatedStatus === REGISTRED_COURSE_STATUS?.REGISTRED){
           if(!isFree){
              setSelectedPlan("")
              setSelectedStudent(item)
              setSelectPlanOpen(true)
              return { ...item };
           } else {
            const freePlanId = plans?.[0]?.id || ""
             updateStudentCourseStatus({
               user_id: id,
               course_id: courseId,
               status: updatedStatus,
               course_currency_id: freePlanId?.toString() || "",
            });
           }
        } else {
         updateStudentCourseStatus({
          user_id: id,
          course_id: courseId,
          status: updatedStatus,
        });    
        }        
        return { ...item, courseStatus: updatedStatus };
      }
      return item;
    });

    setStudentList(updatedStudents);
  };

  const onSavePlan = (selectedStudent)=> {
    if(isPlanExpiryDateValid){
    updateStudentCourseStatus({
      user_id: selectedStudent?.id,
      course_id: courseId,
      status: 1,
      course_currency_id: selectedPlan?.toString() || "",
      expiry_date: planExpiryDate || ""
    });
    const updatedStudents = studentList?.map((item)=>{
        if(item?.id?.toString() === selectedStudent?.id?.toString()){
          return { ...item, courseStatus: 1  }
        } 
        return item
    })
    setStudentList(updatedStudents);
    setSelectedPlan("")
    setSelectedStudent("")
    setSelectPlanOpen(false)
    setPlanExpiryDate("")
    setPlanExpiryDateError("")
    setPlanExpiryDateValid(false)
    } else {
      if (!isPlanExpiryDateValid) {
        setPlanExpiryDateError("Please enter valid expiry date.");
      }
    }
  }

  const handleExpiryDateChange = (date)=>{
   setPlanExpiryDateError("");
   setPlanExpiryDate(date)
   const isValid = date?.toString()?.length > 0;
   setPlanExpiryDateValid(isValid);
  }

  const onPlanChange = (id)=> {
    const selectedPlan = plans?.find((plan)=> plan?.id?.toString() === id?.toString())
     setSelectedPlan(id)
     setPlanExpiryDate(selectedPlan?.expires_at)
     const isValid = selectedPlan?.expires_at?.toString()?.length > 0;
     setPlanExpiryDateValid(isValid);
  }

  return (
    <>
      <Box className="main-screen-container">
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <HeadingComponent
              text={renderTruncatedText(courseName, {limit : 50})}
              fontweigth={600}
              size={40}
              fontfamily={"Montserrat"}
              backNavigation={true}
            />
          </Grid>

          <Grid
            xs={{ marginTop: 2 }}
            xl={{ marginTop: 0 }}
            item
            className="student-search-btn-section"
          >
            <Grid container direction={"row"} justifyContent="space-between">
              <Grid item style={{ paddingRight: "20px" }}>
                <TextIconButtonComponent
                  buttonStyleClass="btn btn-primary"
                  icon={faUserPlus}
                  btnText={"Add New Student"}
                  onclick={() => {
                    navigate("/admin-course-student-new-add-registered", {
                      state: { ...location?.state },
                    });
                  }}
                />
              </Grid>
              <Grid xs={{ marginTop: 2 }} sm={{ marginTop: 2 }} item
              sx={{
                marginTop:{
                  xs: 2,
                  sm: 0,
                  md: 0
                }
              }}
              >
                <TextIconButtonComponent
                  buttonStyleClass="btn btn-secondary"
                  icon={faUserPlus}
                  btnText={"Add Registered Students"}
                  onclick={() => {
                    navigate("/admin-course-student-add-registered", {
                      state: { ...location?.state },
                    });
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box className="common-admin-content-wrap">
          <Box mb={2}> <Typography variant="h6"> Total Active Students: {activeUserCount} </Typography></Box>
          <TableComponent columns={columns} data={studentList} filter={false} />
        </Box>
      </Box>
      <DialogComponent
       title={"Select Plan"}
       children={
         <PlanSelectionDialog
           plans={plans}
           selectedPlan={selectedPlan}
           onPlanChange={(id)=>{
            onPlanChange(id)
           }}
           handleExpiryDateChange={(date)=> { 
              handleExpiryDateChange(date)
           }}
           planExpiryDateError={planExpiryDateError}
           planExpiryDate={planExpiryDate}
         />
       }
       onClose={()=>{
        setSelectedStudent("")
        setSelectedPlan("")
        setSelectPlanOpen(false)
       }}
       open={selectPlanOpen}
       btntextone="Save"
       btntexttwo="Cancel"
       isBtnOneDisabled={!selectedPlan || !planExpiryDate}
       onclickone={()=>{ onSavePlan(selectedStudent) }}
     />
    </>
  );
};

export default connect(
  (state) => ({
    courseStudentsList: state.course.get("courseStudentsList"),
    courseList: state.students.get("commonCourseList"),
    studentStatus: state.students.get("studentStatusUpdate"),
    courseCurrencies: state.course.get("courseCurrencies"),
  }),
  {
    getAdminCourseStudentList: Actions.course.getAdminCourseStudentList,
    updateStudentCourseStatus: Actions.course.updateStudentCourseStatus,
    getCourseList: Actions.students.getCourseList,
    updateStudentStatus: Actions.students.updateStudentStatus,
    getCourseCurruncies: Actions.course.getCourseCurrencies,
  }
)(AdminCourseStudentManageScreen);
